import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({ defaultOptions: { queries: {
    staleTime: 5 * 60 * 1000, gcTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false, retry: false,
} } })
export const apiQueryKey = (userId, endpoint, body = {}) => ['api', userId, body.orgId || '', endpoint, body]

const affectedReads = endpoint => {
    if (/worker|leave|qualification/i.test(endpoint)) return /fetch(Workers|Worker|JobMarket|TimeSheet|Stats|Overview)/
    if (/clienthub|prospect/i.test(endpoint)) return /fetchClientHub/
    if (/client|site/i.test(endpoint)) return /fetch(Clients|Sites|Site|Client|TimeSheet|Invoices|Stats|Overview)/
    if (/allocation|timesheet|clock|shift/i.test(endpoint)) return /fetch(Allocations|Cancelled|Incomplete|TimeSheet|Site|Worker|Invoices|Stats|Overview)/
    if (/invoice|payment|payroll/i.test(endpoint)) return /fetch(Invoice|Payroll|Stats|Client)/
    if (/asset|equipment/i.test(endpoint)) return /fetch(Assets|Allocations|Stats)/
    if (/task|appointment/i.test(endpoint)) return /fetch(Task|Appointment)/
    if (/user|admin|org/i.test(endpoint)) return /fetch/
    return /fetch/
}
export function invalidateApiMutation(endpoint, body = {}) {
    const matches = affectedReads(endpoint)
    return queryClient.invalidateQueries({ predicate: query => query.queryKey[0] === 'api'
        && (!body.orgId || query.queryKey[2] === body.orgId)
        && matches.test(query.queryKey[3] || '') })
}
